function normalizeEnvValue(value: string | undefined) {
  const trimmedValue = value?.trim()
  return trimmedValue ? trimmedValue : undefined
}

export function getOptionalBaseUrl(
  value: string | undefined,
  fallback?: string,
) {
  const resolvedValue = normalizeEnvValue(value) ?? normalizeEnvValue(fallback)
  return resolvedValue?.replace(/\/+$/, "")
}
